import { render } from "./App.vue?vue&type=template&id=04eeb771"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=04eeb771&lang=css"
script.render = render

export default script